import Breadcrumb from "../BreadCrumb/index.js";

function PageHeader({
  selected,
  objects,
  object,
  count,
  title,
  backButton,
  description,
  list = true,
  documentName,
  action,
  breadcrumb,
}) {
  const hasBreadcrumb =
    breadcrumb != null &&
    (Array.isArray(breadcrumb) ? breadcrumb.length > 0 : true);

  return (
    <>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
        <div className="d-flex flex-column gap-1 flex-grow-1 min-w-0">
          {hasBreadcrumb && (
            <>
              {Array.isArray(breadcrumb) ? (
                <Breadcrumb items={breadcrumb} />
              ) : (
                breadcrumb
              )}
            </>
          )}
          <div className="d-flex gap-3 align-items-center">
            {backButton && (
              <button
                className="btn btn-link p-0 d-flex align-items-center justify-content-center p-2 p-lg-1 bg-white border"
                style={{
                  borderRadius: "8px",
                  textDecoration: "none",
                  transition: "all 0.2s ease",
                }}
                onClick={() => window.history.back()}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.03)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 5px rgba(0, 0, 0, 0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 1px 3px rgba(0, 0, 0, 0.12)";
                }}
              >
                <i
                  className="bi bi-chevron-left text-primary"
                  style={{ fontSize: "1.25rem" }}
                ></i>
              </button>
            )}

            {list ? (
              <div className="d-flex flex-column gap-1">
                <h2
                  className="fw-bold m-0 text-primary"
                  style={{
                    fontSize: "1.75rem",
                    letterSpacing: "-0.02em",
                  }}
                >
                  {title}
                </h2>

                {description && (
                  <p className="text-muted fs-6">{description}</p>
                )}

                {count !== undefined && (
                  <p
                    className="text-muted m-0 fw-medium"
                    style={{ fontSize: "0.9rem" }}
                  >
                    {selected && selected.length > 0
                      ? `${selected.length} of ${count} selected`
                      : `Total: ${objects?.length || 0} of ${count || 0}`}
                  </p>
                )}
              </div>
            ) : (
              <div className="d-flex flex-column gap-1">
                <h2
                  className="fw-bold m-0 text-primary"
                  style={{
                    fontSize: "1.75rem",
                    letterSpacing: "-0.02em",
                  }}
                >
                  {object?.id ? "Edit" : "Add"} {documentName || "Document"}
                </h2>

                {description && (
                  <p className="text-muted fs-6">{description}</p>
                )}
              </div>
            )}
          </div>
        </div>

        {typeof action === "function" && action()}
      </div>
    </>
  );
}

export default PageHeader;
